import { GameInventoryItem } from "@shared/types";
import { BaseRouteService } from "./BaseRouteService";

/**
 * Service to communicate with inventory routes of the server application
 */
export class InventoryRouteService extends BaseRouteService {
    /**
     * Get the inventory for the current player
     *
     * @returns A list of game objects in the player's inventory
     */
    public async getInventory(): Promise<GameInventoryItem[]> {
        return await this.getJsonApi<GameInventoryItem[]>("inventory");
    }

    /**
     * Try to delete an item from the current player's inventory
     *
     * @param item - Alias of the item to delete
     * @returns A boolean indicating if the item was deleted
     */
    public async removeItemFromInventory(item: string): Promise<boolean> {
        try {
            await this.deleteJsonApi(`inventory/${item}?force=true`); // TODO: Remove force parameter
            return true;
        }
        catch {
            return false;
        }
    }
}
